module.exports = __webpack_public_path__ + "images/category_lp/bike/new/assessment_achievements/5_449252f3f60b58261e2b6e9f6aaa7bfe.png";